import { render, staticRenderFns } from "./OnDemandViewRatio.vue?vue&type=template&id=1dc89604&scoped=true&"
import script from "./OnDemandViewRatio.vue?vue&type=script&lang=js&"
export * from "./OnDemandViewRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc89604",
  null
  
)

export default component.exports